export default {
  corePageLoadComplete: false,
  mobileMenuOpen: false,
  floatingFooterVisible: false,
}
